<template>
    <!-- <a class="navbar-item" href="javascript:void(0)" v-on:click="logoff" v-show="isAuthenticated">Logoff {{profile.firstName}}</a> -->
    <!-- <router-link to="/register"  class="navbar-item" v-show="!isAuthenticated">Email signup</router-link>      -->

    <nav class="navbar navbar-expand-lg">
      <router-link :to="{name: 'Home'}" class="navbar-brand mb-0 h1">lookeoo</router-link>
      <!-- <span class="navbar-brand mb-0 h1">lookeoo</span> -->

      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <router-link :to="{name: 'SearchList'}" class="nav-link">Mes recherches</router-link>
          </li>

          <li class="nav-item">
            <router-link :to="{name: 'SearchAdd'}" class="nav-link">Créer une recherche</router-link>
          </li>
        </ul>

        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <!-- <a class="nav-link" href="javascript:void(0)" v-show="isAuthenticated" @click="logoff()">Vous êtes connectés</a> -->
            <router-link :to="{name: 'UserAccount'}" class="nav-link" v-show="isAuthenticated">Mon compte</router-link>
            <!-- <span class="nav-link">Connectez-vous</span> -->
            <router-link :to="{name: 'UserLogin'}" class="nav-link" v-show="!isAuthenticated">Connectez-vous</router-link>
          </li>
        </ul>
      </div>
    </nav>
</template>

<script>
// import { Component, Vue } from 'vue-property-decorator';
// import { EventBus } from '.././event-bus';
import { mapGetters } from 'vuex';

export default {
    name: 'Nav',
    computed: mapGetters({
        isAuthenticated: 'isAuthenticated',
        // profile: 'user/profile',
    }),
    methods: {
        created: function() {
            // EventBus.$on('logged-in', (payLoad) => {
            //     // this doesn't currently do anything in this demo but does get fired on successful login.
            //     // leaving it here to show how to allow communication between unrelated components - ie. Store -> Component
            //     console.log('logged-in message received...');
            // });
        },
        destroyed: function() {
            EventBus.$off('logged-in');
        }
    }
  
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
nav{
  background: #2c3e50;
}

.navbar-brand{
  color: #1abc9c;
  margin-right: 80px;
}

nav .navbar-brand.router-link-exact-active{
  color: #1abc9c !important;
  background: none !important;
}

nav .nav-link{
  color: white;
  text-transform: uppercase;
  font-weight: bold;
  font-family: Montserrat,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  margin-right: 40px;
}

nav .nav-link:hover{
  color: #1abc9c;
}

nav .router-link-exact-active {
  color: #fff !important;
  background: #1abc9c;
  border-radius: 5px;
}

.navbar-toggler-icon{
  background-image:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(255, 255, 255, 0.5)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}
</style>



// WEBPACK FOOTER //
// src/components/template/Nav.vue